import { SET_AD_GROUPS } from './events';

export type AdGroupsState = string[];
const defaultState: AdGroupsState = [];

export default function adGroups(
  state: AdGroupsState = defaultState,
  action: any
): AdGroupsState {
  switch (action.type) {
    case SET_AD_GROUPS:
      return action.payload;
    default:
      return state;
  }
}

export const adGroupsSelector = (state: any): string[] => state.adGroups || [];

